import {h, Fragment} from "preact"
import { AutocompleteElement } from "@nosto/preact"
import { closeSearchOverlay } from "../search"
import { searchSuggestionsFallback } from "../config"

export default function History() {

    return (
        <div class="ns-autocomplete ns-fixed ns-flex ns-flex-col ns-lg-grid">
            <div class="ns-keywords">
                <h4 class="ns-section-title">Search Suggestions</h4>
                <ul class="ns-keyword-list ns-flex ns-flex-col">
                    {(window.nostoSearchSuggestions || searchSuggestionsFallback).map(item => (
                        <AutocompleteElement
                            key={item.text}
                            hit={{ 
                                keyword: item.text, 
                                _redirect: item.url || null, 
                                url: item.url || null
                            }}
                        >
                            {item.text}
                        </AutocompleteElement>
                    ))}
                </ul>
            </div>
            
            <nosto-campaign 
                id="searchdropdown-nosto-1" 
                class="ns-autocomplete-products"
            />

            <button
                type="button"
                aria-label="Close search"
                class="ns-close-search-btn ns-absolute"
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    closeSearchOverlay();
                }}
            >
                <svg aria-hidden="true" focusable="false" role="presentation" width="7.8" height="7.8" class="icon icon-close" viewBox="0 0 20 20">
                    <path d="M16.4 2.2L10 8.6 3.6 2.2 2.2 3.6 8.6 10l-6.4 6.4 1.4 1.4 6.4-6.4 6.4 6.4 1.4-1.4-6.4-6.4 6.4-6.4z"></path>
                </svg>
            </button>
        </div>
    )
}
